var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDripIcon15X15 = function SvgDripIcon15X15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57421",
    transform: "translate(0 -.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20045",
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "translate(0 .4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 601 \\u2013 5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108622",
    d: "m6.143 2.973 1.354-1.924c1.452 2.135 2.96 4.119 4.218 6.268a5.077 5.077 0 0 1-1.315 6.371 4.6 4.6 0 0 1-6.245-.342 5.312 5.312 0 0 1-.682-6.507c.829-1.302 1.749-2.538 2.67-3.866Z"
  })))));
};
export default SvgDripIcon15X15;